import { createAction } from '@reduxjs/toolkit';

export const updateFilters = createAction('updateFilters');
